"use strict";

var _interopRequireDefault = require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/Users/mweeb/Desktop/codings/nq-component/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _RelatedFactory = _interopRequireDefault(require("../RelatedFactory"));
var _excluded = ["onChange", "schema", "label", "field", "defaultValue"];
var _jsxFileName = "/Users/mweeb/Desktop/codings/nq-component/src/InputRelation/index.js";
var defaultProps = {};
function InputRelation(_ref) {
  var onChange = _ref.onChange,
    schema = _ref.schema,
    label = _ref.label,
    field = _ref.field,
    defaultValue = _ref.defaultValue,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _schema = {
    collection: props.target,
    fields: {}
  };
  _schema.fields[field] = {
    type: 'Pointer',
    target: props.target,
    label: label,
    col: "col-10"
  };
  var _onChange = function _onChange(value) {
    onChange(value.reduce(function (acc, cur) {
      if (cur[field] && Object.keys(cur[field]).length > 0) {
        acc.push(cur[field]);
      }
      return acc;
    }, []));
  };
  var mapValue = function mapValue() {
    return defaultValue.map(function (o) {
      var object = {};
      object.id = o.id;
      object[field] = o;
      return object;
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_RelatedFactory["default"], Object.assign({
    col: "col=12",
    onChange: _onChange,
    schema: _schema,
    defaultValue: defaultValue && mapValue()
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36,
      columnNumber: 12
    }
  }));
}
InputRelation.defaultProps = defaultProps;
var _default = exports["default"] = InputRelation;